import React from "react";
import { ExerciseTypeContainer } from "./ExerciseTypeContainer";
import ReactMarkdown from "react-markdown";
import { ExerciseItem, getExerciseContent } from "@/services/student/exercise.interfaces";

// Interface para o conteúdo do exercício FormattedText
interface FormattedTextContent {
  title: string;
  content: string;
  imageUrl?: string;
  imageAlt?: string;
  backgroundColor?: string;
}

// Props do componente
type FormattedTextProps = {
  item: ExerciseItem;
};

export const FormattedText: React.FC<FormattedTextProps> = ({ item }) => {
  // Extrair e tipar o conteúdo do exercício
  const content = getExerciseContent<FormattedTextContent>(item);

  // Estilo para o container do conteúdo
  const contentContainerStyle = {
    backgroundColor: content.backgroundColor || "#f9f9f9",
    padding: "1.5rem",
    borderRadius: "0.5rem",
  };

  return (
    <ExerciseTypeContainer
      item={item}
      title1={item.title || ""}
      title2={content.title}
      exerciseNumber={item.id.toString()}
      hideVerifyButton={true}
    >
      <div style={contentContainerStyle} className="formatted-text-container">
        {/* Imagem opcional */}
        {content.imageUrl && (
          <div className="mb-4">
            <img
              src={content.imageUrl}
              alt={content.imageAlt || "Imagem ilustrativa"}
              className="max-w-full h-auto rounded-md"
            />
          </div>
        )}

        {/* Conteúdo formatado usando Markdown */}
        <div className="prose max-w-none" style={{ fontSize: '20px', fontWeight: '200', lineHeight: '1.8' }}>
          <ReactMarkdown>{content.content }</ReactMarkdown>
        </div>
      </div>
    </ExerciseTypeContainer>
  );
}; 